import React, { useState } from "react";
import { ReactComponent as EyeOpen } from "../../assets/icons/eye.svg";
import { ReactComponent as EyeClosed } from "../../assets/icons/eye-slash.svg";
import { Link } from "react-router-dom";

const backgroundContainer: React.CSSProperties = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "#124280",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 0,
};

const containerStyle: React.CSSProperties = {
  width: 521,
  height: 530,
  background: "#fff",
  borderRadius: 12,
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  padding: "50px 34px",
  boxSizing: "border-box",
  zIndex: 1,
};

const inputContainerStyle: React.CSSProperties = {
  width: "100%",
  maxWidth: 454,
  height: 54,
  border: "1px solid #000",
  borderRadius: 8,
  display: "flex",
  alignItems: "center",
  paddingLeft: 18,
  marginBottom: 28,
  boxSizing: "border-box",
  background: "#fff",
  position: "relative",
};

const inputStyle: React.CSSProperties = {
  fontFamily: "Poppins, sans-serif",
  fontWeight: 500,
  fontSize: 16,
  color: "#8A8A8A",
  outline: "none",
  border: "none",
  background: "transparent",
  height: "100%",
  width: "100%",
  paddingRight: 36,
};

const eyeIconStyle: React.CSSProperties = {
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)",
  cursor: "pointer",
  fontSize: 22,
  color: "#8A8A8A",
  background: "none",
  border: "none",
  display: "flex",
  alignItems: "center",
};

const senhaContainerStyle: React.CSSProperties = {
  ...inputContainerStyle,
  marginBottom: 25,
};

const linkStyle: React.CSSProperties = {
  fontFamily: "Poppins, sans-serif",
  fontWeight: 500,
  fontSize: 16,
  color: "#9E201E",
  marginBottom: 20,
  cursor: "pointer",
};

const cadastroStyle: React.CSSProperties = {
  ...linkStyle,
  color: "#124280",
};

const buttonStyle: React.CSSProperties = {
  width: 454,
  height: 50,
  background: "#124280",
  borderRadius: 8,
  color: "#fff",
  fontFamily: "Poppins, sans-serif",
  fontWeight: 500,
  fontSize: 24,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "none",
  cursor: "pointer",
  marginBottom: 0,
};

const RecuperarSenhaContainer: React.FC = () => {
  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div style={backgroundContainer}>
      <div style={containerStyle}>
        <div
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: 500,
            fontSize: 50,
            color: "#000",
            marginBottom: 5,
            textAlign: "left",
            width: "100%",
          }}
        >
          Redefinir Senha
        </div>
        <div
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: 500,
            fontSize: 14,
            color: "#000",
            marginBottom: 30,
            textAlign: "left",
            width: "100%",
          }}
        >
          Recuperar senha da conta
        </div>
        <div style={inputContainerStyle}>
          <input
            style={inputStyle}
            type="text"
            value={emailOrPhone}
            onChange={(e) => setEmailOrPhone(e.target.value)}
            placeholder="Id do Usuário"
          />
        </div>
        <div style={inputContainerStyle}>
          <input
            style={inputStyle}
            type="text"
            value={emailOrPhone}
            onChange={(e) => setEmailOrPhone(e.target.value)}
            placeholder="Senha"
          />
        </div>
        <div style={senhaContainerStyle}>
          <input
            style={inputStyle}
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Confirmar Senha"
          />
          <span
            style={eyeIconStyle}
            onClick={() => setShowPassword((v) => !v)}
            tabIndex={0}
            aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
            role="button"
          >
            {showPassword ? <EyeClosed /> : <EyeOpen />}
          </span>
        </div>

        <div style={cadastroStyle}>
          <Link
            to="/entrar"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            Lembrei minha senha
          </Link>
        </div>
        <button style={buttonStyle}>Redefinir Senha</button>
      </div>
    </div>
  );
};

export default RecuperarSenhaContainer;
